/** @format */

import { middlwareSaga } from "./middlewareSaga";

export const middlewares = [middlwareSaga];
